export const BUTTON_DISPLAY_MODES = {
  ICON: "icon",
  ICON_TEXT: "icon-text"
};

export const FILTER_OPERATORS_DATA = {
  CONTAINS: { key: "contains", display_key: "contains" },
  NOT_CONTAINS: { key: "does_not_contain", display_key: "does not contain" },
  IS: { key: "is", display_key: "is" },
  IS_NOT: { key: "is_not", display_key: "is not" },
  STARTS_WITH: { key: "starts_with", display_key: "starts with" },
  ENDS_WITH: { key: "ends_with", display_key: "ends with" },
  GREATER_THAN_OR_EQUAL_TO: { key: "greater_than_or_equal_to", display_key: "greater than or equal to", hideInMenu: true },
  LESS_THAN_OR_EQUAL_TO: { key: "less_than_or_equal_to", display_key: "less than or equal to", hideInMenu: true }
};

export const FILTER_OPERATORS = Object.values(FILTER_OPERATORS_DATA);
